import Modal from '@/components/modules/Modal';
import Filters from '@/components/modules/filters/Filters';
import { FilterProps } from '@/components/modules/filters/Filters/FiltersContainer';

interface FilterModalProps extends FilterProps {
  onClose: () => void;
  showFilters: boolean;
}

export const FilterModal = ({
  showFilters,
  onClose,
  filters,
  onFilter,
}: FilterModalProps) => {
  if (!showFilters) return null;
  return (
    <Modal clickOffToClose={true} size="xl" onClose={onClose}>
      <div className="pt-6 pb-4">
        <h1 className="px-4 mb-4 font-medium">{'Filter Attributes'}</h1>
        <Filters filters={filters} onFilter={onFilter} />
      </div>
    </Modal>
  );
};
